module.exports = __webpack_public_path__ + "5ad1c660106bbd7805f991abf57f9d8e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/ice-cream.png
// module id = 2543
// module chunks = 0